import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '../../NatureOfBusinessFormProvider/types';
import { filterAndSortBySubgroup } from '../utils';
import ExportIncomeOtherForm from './ExportIncomeOtherForm';
import ExportIncomeEditButton from './ExportIncomeActions/ExportIncomeEditButton';
import ExportIncomeDeleteButton from './ExportIncomeActions/ExportIncomeDeleteButton';
import ExportIncomeYearFieldsForm from './ExportIncomeYearFieldsForm';

const ExportIncomeExtendedForm = () => {
  const { watch } = useNatureOfBusinessForm();
  const incomeStructure = watch(
    'incomeStructure'
  ) as IIncomeStructureFormValues;

  const exportIncomeItems = incomeStructure?.exportIncomeItems || {};
  const exportIncomeExtended = filterAndSortBySubgroup(
    exportIncomeItems,
    INCOME_SUBGROUP_CATEGORY.EXPORT_INCOME
  );

  return (
    <>
      {exportIncomeExtended.map(([key, item]) => (
        <Flex key={key} width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350} justifyItems={'end'}>
            <InputLabel sx={{ textAlign: 'right' }}>
              ประเทศ{item.incomeCategory?.nameTh}
            </InputLabel>
            <Flex alignItems={'center'}>
              <Typography textAlign={'right'} color={'text.secondary'}>
                (พันบาท)
              </Typography>
              <ExportIncomeEditButton keyItem={key} />
              <ExportIncomeDeleteButton keyItem={key} />
            </Flex>
          </Box>
          <ExportIncomeYearFieldsForm keyItem={key} />
        </Flex>
      ))}
      {exportIncomeExtended.length > 0 && <ExportIncomeOtherForm />}
    </>
  );
};

export default ExportIncomeExtendedForm;
